// test/list-my-test
import { returnErrors } from './errorAction';
import { RESET_MY_TESTS, GET_MY_TESTS, GET_NEXT_MY_TESTS, NO_MY_TESTS, CREATE_MY_TEST, UPDATE_MY_TEST, GET_QUESTION_SOURCE, GET_SKILLS, GET_TOPICS, EMPTY_TOPICS, GET_COUNT, RESET_SKILLS, RESET_TOPICS, RESET_QUESTION, GET_TEST_BY_ID } from '../Types/types';
import { getApiCall, getV2ApiCall, handle403Logout, postApiCall, postApiCall2 } from '../../utils/request';

export const resetMYTest = () => async (dispatch) => {
    try {
        dispatch({ type: RESET_MY_TESTS });
    }
    catch (error) {
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const getMyTests = (testType, query, page, row) => async (dispatch) => {
    try {
        const response = await getApiCall(`mytest/list-test?TestType=${testType}&SearchText=${query}&PageNumber=${page}&DisplayRows=${row}`);
        if (response?.status === 200) {
            dispatch({ type: GET_MY_TESTS, payload: response.data });
        } else if (response?.status === 204) {
            dispatch({ type: NO_MY_TESTS });
        }
        else {
            dispatch({ type: NO_MY_TESTS });
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const getNextMyTests = (testType, query, page, row) => async (dispatch) => {
    try {
        const response = await getApiCall(`mytest/list-test?TestType=${testType}&SearchText=${query}&PageNumber=${page}&DisplayRows=${row}`);
        if (response?.status === 200) {
            dispatch({ type: GET_NEXT_MY_TESTS, payload: response.data });
        } else if (response?.status === 204) {
            dispatch({ type: NO_MY_TESTS });
        }
        else {
            // returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}



export const savedTest = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`mytest/create-test`, obj);
        if (response?.status === 200) {
            returnErrors(dispatch, 'Test has been created', 200);
            return dispatch({ type: CREATE_MY_TEST, payload: response.data });
        }
        else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const updateTest = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`mytest/update-test`, obj);
        if (response?.status === 200) {
            returnErrors(dispatch, 'Test has been updated', 200);
            return dispatch({ type: UPDATE_MY_TEST, payload: response.data });
        }
        else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const getQuestionSource = () => async (dispatch) => {
    try {
        const response = await getApiCall(`mytest/list-question-source`);
        if (response.status === 200) {
            return dispatch({ type: GET_QUESTION_SOURCE, payload: response.data.questionSources })
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, 'Something went wrong', error?.response?.status);
    }
}

export const getSkills = (sourceType, testType, CodingLanguageId = null) => async (dispatch) => {
    try {
        let params = [];
        if (sourceType !== null && sourceType !== undefined && sourceType !== '') {
            params.push(`QuestionSourceType=${sourceType}`);
        }
        if ((testType === 7 || testType === 8) && CodingLanguageId) {
            params.push(`CodingLanguageId=${CodingLanguageId}`);
        }
        let url = `mytest/list-knowledge-area${params.length ? `?${params.join('&')}` : ''}`;
        const response = await getApiCall(url);
        if (response.status === 200) {
            return dispatch({ type: GET_SKILLS, payload: response.data.knowledgeAreas })
        } else if (response.status === 204) {
            dispatch({ type: RESET_QUESTION });
            return { type: 'NO_SKILLS' };
        } else {
            dispatch({ type: RESET_QUESTION });
            return { type: 'NO_SKILLS' };
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, 'Something went wrong', error?.response?.status);
    }
}

export const resetSkills = () => (dispatch) => {
  dispatch({ type: RESET_SKILLS });
};

export const getSkillTopics = (sourceType, skillId, testType, CodingLanguageId) => async (dispatch) => {
    try {
        let params = [];
        if (sourceType !== null && sourceType !== undefined && sourceType !== '') {
            params.push(`QuestionSourceType=${sourceType}`);
        }
        params.push(`KnowledgeAreaId=${skillId}`);
        if ((testType === 7 || testType === 8) && CodingLanguageId) {
            params.push(`CodingLanguageId=${CodingLanguageId}`);
        }
        let url = `mytest/list-topic${params.length ? `?${params.join('&')}` : ''}`;
        const response = await getApiCall(url);
        if (response.status === 200) {
            return dispatch({ type: GET_TOPICS, payload: response.data.topics })
        } else if (response.status === 204) {
            dispatch({ type: EMPTY_TOPICS });
            return { type: 'NO_TOPICS' };
        } else {
            dispatch({ type: EMPTY_TOPICS });
            return { type: 'NO_TOPICS' };
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, 'Something went wrong', error?.response?.status);
    }
}

export const resetTopics = () => (dispatch) => {
  dispatch({ type: RESET_TOPICS });
};

export const emptyTopics = () => async (dispatch) => {
    dispatch({
        type: EMPTY_TOPICS
    })
}

export const getQuestionCount = (sourceType, skillId, topicId, level) => async (dispatch) => {
    try {
        const response = await getApiCall(`mytest/get-question-count?QuestionSourceType=${sourceType}&KnowledgeAreaId=${skillId}&TopicId=${topicId}&QuestionLevelId=${level}`);
        if (response.status === 200) {
            return dispatch({ type: GET_COUNT, payload: response.data.count })
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, 'Something went wrong', error?.response?.status);
    }
}

export const getCodingQuestionCount = (sourceType, skillId, topicId, level, CodingLanguageId) => async (dispatch) => {
  try {
    const response = await getApiCall(
      `mytest/get-coding-question-count?QuestionSourceType=${sourceType}&KnowledgeAreaId=${skillId}&TopicId=${topicId}&QuestionLevelId=${level}&CodingLanguageId=${CodingLanguageId}`
    );
    if (response.status === 200) {
      return dispatch({ type: GET_COUNT, payload: response.data.count });
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, 'Something went wrong', error?.response?.status);
  }
};

export const getTechSkills = (CodingLanguageIds = []) => async (dispatch) => {
    try {
        const langParams = CodingLanguageIds.length
            ? CodingLanguageIds.map(id => `CodingLanguageIds=${id}`).join('&')
            : '';
        const url = `mytest/tech-list-knowledge-area${langParams ? `?${langParams}` : ''}`;
        const response = await getApiCall(url);
        if (response.status === 200) {
            return dispatch({ type: GET_SKILLS, payload: response.data.knowledgeAreas });
        } else if (response.status === 204) {
            dispatch({ type: RESET_QUESTION });
            return { type: 'NO_SKILLS' };
        } else {
            dispatch({ type: RESET_QUESTION });
            return { type: 'NO_SKILLS' };
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, 'Something went wrong', error?.response?.status);
    }
};

export const getTechSkillTopics = (skillId, CodingLanguageIds = []) => async (dispatch) => {
    try {
        const langParams = CodingLanguageIds.length
            ? CodingLanguageIds.map(id => `CodingLanguageIds=${id}`).join('&')
            : '';
        let url = `mytest/tech-list-topic?KnowledgeAreaId=${skillId}`;
        if (langParams) url += `&${langParams}`;
        const response = await getApiCall(url);
        if (response.status === 200) {
            return dispatch({ type: GET_TOPICS, payload: response.data.topics });
        } else if (response.status === 204) {
            dispatch({ type: EMPTY_TOPICS });
            return { type: 'NO_TOPICS' };
        } else {
            dispatch({ type: EMPTY_TOPICS });
            return { type: 'NO_TOPICS' };
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, 'Something went wrong', error?.response?.status);
    }
};

export const getTechCodingQuestionCount = (sourceType, skillId, topicId, level, CodingLanguageIds = []) => async (dispatch) => {
    try {
        const langParams = CodingLanguageIds.length
            ? CodingLanguageIds.map(id => `CodingLanguageIds=${id}`).join('&')
            : '';
        let url = `mytest/tech-get-coding-question-count?QuestionSourceType=${sourceType}&KnowledgeAreaId=${skillId}&TopicId=${topicId}&QuestionLevelId=${level}`;
        if (langParams) url += `&${langParams}`;
        const response = await getApiCall(url);
        if (response.status === 200) {
            return dispatch({ type: GET_COUNT, payload: response.data.count });
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, 'Something went wrong', error?.response?.status);
    }
};

export const savedTechTest = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall2(`mytest/create-test`, obj);
        if (response?.status === 200) {
            returnErrors(dispatch, 'Test has been created', 200);
            return dispatch({ type: CREATE_MY_TEST, payload: response.data });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
};

export const updateTechTest = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall2(`mytest/update-test`, obj);
        if (response?.status === 200) {
            returnErrors(dispatch, 'Test has been updated', 200);
            return dispatch({ type: UPDATE_MY_TEST, payload: response.data });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
};

export const getTechTestById = (id) => async (dispatch) => {
    try {
        const response = await getV2ApiCall(`mytest/get-test?TestId=${id}`);
        if (response.status === 200) {
            return dispatch({ type: GET_TEST_BY_ID, payload: response.data.myTest });
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, 'Something went wrong', error?.response?.status);
    }
};